import React, { Component } from "react";
// import {
//   Icon,
//   //Image
// } from "semantic-ui-react";
import { connect } from "react-redux";
import ReactPlayer from "react-player/youtube";
import { closeModal } from "../../actions/modalAction";
import { MdClose } from "react-icons/md";

class ShowVideo extends Component {
  render() {
    const renderVideos = () => {
      if (this.props.videoPath) {
        return (
          <div className="player-wrapper">
            <ReactPlayer
            //light={true}
              //playing
              controls={true}
              className="react-player"
              url={this.props.videoPath}
              width="100%"
              height="100%"
            />
          </div>
        );
      } else {
        return <div className="card-noShow">Oops ! No Video Available</div>;
      }
    };
    //***** */
    return (
      <div
        style={{
          position:'relative',
          borderRadius: 3,
          fontSize: "16px",
          fontWeight: "bold",
          //background:'transparent',
          backgroundColor: "black",
          margin: "0px",
          padding: "0px",
        }}
      >
        <div className="pos-abs">
          <span
            className="icon-button border1 flex-center"
            onClick={this.props.closeModal}
            style={{ color: "white", fontSize: "24px", }}
          >
            <MdClose />
          </span>
        </div>

        {renderVideos()}
      </div>
    );
  }
}

export default connect(null, { closeModal })(ShowVideo);
